module.exports = __webpack_public_path__ + "media/images/landing_page/dashboard_mobile-a91447aca75d9d7bd58d130dcdc65e8b.webp";